import { type BoxProps } from '@chakra-ui/react';
import { useDesiredChain } from '@cronos-app/wallet';
import { TokenSelector } from '@ui/components/Input/TokenSelector';
import { ToTokenCard } from '@ui/components/SwapDialog/ToTokenCard';
import { Token } from '@ui/config/token';
import { TOKEN_LIST } from '@ui/config/token/tokenConfig';
import { useTokenBalance } from '@ui/hooks/contracts/useTokenBalance';
import { useTokenConfig } from '@ui/hooks/contracts/useTokenConfig';
import { useTokenPrice } from '@ui/hooks/tokenPrice';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';
import { useMemo } from 'react';

import { useH2SwapDialog } from '../../useH2SwapDialog';
import { H2NormalTokenSelector } from './H2NormalTokenSelector';
import { useH2SwapForm } from './useH2SwapForm';
import { useToTokenAmount } from './useToTokenAmount';

export const H2ToTokenCard = (props: BoxProps) => {
  const toToken = useH2SwapForm((s) => s.toToken);
  const agentAddress = useH2SwapDialog((s) => s.agentTokenAddress);
  const bondingAddress = useH2SwapDialog((s) => s.bondingTokenAddress);
  const chainLayer = useGlobalChainLayer();
  const chainId = useDesiredChain(chainLayer);
  const tokenList = useMemo(
    () => TOKEN_LIST[chainId].filter((t) => t !== Token.zkCRO),
    [chainId],
  );

  const toTokenAmount = useToTokenAmount();

  const toTokenPrice = useTokenPrice({
    token:
      toToken === Token.Agent
        ? { type: Token.Bonding, bondingAddress }
        : toToken,
  }).data?.usd_price;
  const toTokenInfo = useTokenConfig({
    token: toToken,
    tokenAddress: agentAddress,
  });

  const toTokenBalance = useTokenBalance({
    tokenAddress: toTokenInfo?.address,
  }).data;

  const tokenSelector =
    toToken === Token.Agent ? (
      <TokenSelector token={toToken} tokenAddress={agentAddress} />
    ) : (
      <H2NormalTokenSelector tokenList={tokenList} isSelectable />
    );

  return (
    <ToTokenCard
      toTokenAmount={toTokenAmount}
      toTokenInfo={toTokenInfo}
      toTokenPrice={toTokenPrice}
      toTokenBalance={toTokenBalance}
      tokenSelector={tokenSelector}
      {...props}
    />
  );
};
